import { useEffect, useState, lazy } from "react";
import Navbar from "../../Component/navbar/Navbar";
import UserNavbar from "../../Component/user/UserNavbar";
import { useSelector } from "react-redux";
import "./style.css";

//STATIC AND Dynamic QR Images
import s1 from "../../asset/guide/Rectangle 40471-email-guide-static.webp";
import s2 from "../../asset/guide/Rectangle 40474-wifi-guide-static.webp";
import s3 from "../../asset/guide/Rectangle 40473-vcard-guide-static.webp";
import s4 from "../../asset/guide/Rectangle 40384-sms-guide-static.webp";

import d1 from "../../asset/guide/Rectangle 40463-email-guide-dynamic.webp";
import d2 from "../../asset/guide/Rectangle 40469-wifi-guide-dynamic.webp";
import d3 from "../../asset/guide/Rectangle 40467-vcard-guide-dynamic.webp";
import d4 from "../../asset/guide/Rectangle 40471-sms-guide-dynamic.webp";

//Anatomy Section Images :

import an1 from "../../asset/guide/Group 1000003017-1-anatomy.webp";
import an2 from "../../asset/guide/Group 1000003018-2-anatomy (1).webp";
import an3 from "../../asset/guide/Group 1000003040-3-anatomy.webp";
import an4 from "../../asset/guide/Group 1000003043-4-anatomy (1).webp";
import an5 from "../../asset/guide/Group 1000003044-5-anatomy.webp";

//Marketing Images
import marketingImg from "../../asset/guide/marketing.webp";

//Common Use Images
import cu1 from "../../asset/guide/Rectangle 40411-1-guide-commonuse.webp";
import cu2 from "../../asset/guide/Rectangle 40411-2-guide-commonuse.webp";
import cu3 from "../../asset/guide/Rectangle 40411-3-guide-commonuse.webp";
import cu4 from "../../asset/guide/Rectangle 40413-4-guide-commonuse.webp";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const KnowAbout = lazy(() => import("../../Component/KnowAbout/KnowAbout"));
const Footer = lazy(() => import("../../Component/Footer/Footer"));

const BeginnersGuide = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const userState = useSelector((state) => state.user);
  const currentUserId = userState.currentUserId;

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const navigateTo = () => {
    if (!currentUserId) {
      return navigate("/signUp", {
        state: {
          path: "/user/create/feild/dynamic/businessDynamic",
        },
      });
    }
    navigate("/user/create/feild/dynamic/businessDynamic");
  };

  return (
    <div className="wrapper">
      <Helmet>
        <title>The Ultimate Guide to QR Codes | QR Code Generator</title>
        <meta
          name="description"
          content="The complete QR Code guide for creating, designing, tracking, and printing your QR Codes. Get started with a free account!"
        />
        <meta name="keywords" content="QR Code Guides   Free QR Code Generator     QR Code Generatorr" />
        <meta name="theme-color" content="#008f68" />
        <link rel="canonical" href="https://www.qrcodebrew.com/qr-code-beginners" />
      </Helmet>
      {currentUserId ? <UserNavbar setShowSidebar={setShowSidebar} showSidebar={showSidebar} /> : <Navbar />}

      <div
        className="qrbrew-main "
        style={{
          margin: "auto",
          textAlign: "center",
          overflow: "clip",
        }}
      >
        {/* HERO */}
        <section className="section-guide-hero wrapperWidth margin-t-20">
          <div>
            <h1 className="hero-title">
              QR CODE 101 :{" "}
              <span className="gold-color" style={{ fontSize: "38px" }}>
                A Beginners Guide
              </span>
            </h1>
          </div>
          <div className="guide-pt-20 hero-img">
            <img loading="eager" src={'/assets/GuideHero.webp'} alt="QR Code Guides" />
          </div>
          <div className="guide-pt-20 hero-img-caption">
            {/* <p>A bit like the Huns in Mulan, QR Codes are popping out of the snow like daisies. You can now find them enhancing your favorite product packaging, or optimizing the effectiveness of your business cards and resumes. You are intrigued by the potential of these Codes, and we have answers.</p> */}
            <p style={{ fontSize: "22px", lineHeight: "36px" }}>
              This guide is a comprehensive online resource that aims to introduce QR codes and their functionality to individuals who are new to the concept.
              Whether you're a marketer, business owner, or just curious about QR codes, here is the perfect starting point to unlock the potential of this
              powerful tool.
            </p>
          </div>
          Earn more followers
        </section>

        <section className="section-guide-hero-hero wrapperWidth passup-wrapper zero-display">
          {/* <div>
                          <p className="passupText">Pass Up : </p>
                      </div> */}
          {/* FLEX */}
          <div className="container wrapper guide-pt-20 mobile-width-100">
            <div className="row">
              <div className="col">
                <a href="#what-is-qr">
                  <p>
                    <nobr>QR Code Work</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#how-to-scan">
                  <p>
                    <nobr>Scan QR Code</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#static-and-dynamic">
                  <p>
                    <nobr>Static & Dynamic</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#uses-of-qr">
                  <p>
                    <nobr>Use of QR</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#faq">
                  <p>
                    <nobr>FAQ</nobr>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="section-guide-hero-hero guide-wrapper paddingLeft wrapperWidth">
          <div className="mobile-width-100" style={{ textAlign: "left", margin: "auto" }}>
            <div className="section-guide-hero-hero" id="what-is-qr">
              <h2 className="s3-heading">
                What is a QR Codes, and{" "}
                <span className="gold-color" style={{ fontSize: "inherit" }}>
                  how does it work ?
                </span>
              </h2>
              <p className="s3-text guide-pt-20">
                A QR Code is a machine-readable code scanned using a smartphone or QR code reader to access information or content. It consists of black and
                white squares organized in a specific pattern and can store a large amount of data, including text, URLs, and other types of information.QR
                codes work by using a particular type of encoding that allows data to be stored in both the horizontal and vertical dimensions of the code. You
                can use QR codes for many purposes, including marketing, advertising, and authentication. They can be printed on products, posters, or other
                materials, and users can quickly scan them using their smartphones to access additional information or content. QR codes are a seamless and
                efficient way to share information and engage customers.
              </p>
            </div>

            <div className="section-guide-hero-hero" id="how-to-scan">
              <h2 className="s3-heading">
                How to{" "}
                <span className="gold-color" style={{ fontSize: "inherit" }}>
                  scan{" "}
                </span>{" "}
                a QR Code?
              </h2>
              <p className="s3-text guide-pt-20">
                Open your{" "}
                <Link to="/qr-code-digital-media" className="s4-textBlue">
                  {" "}
                  smartphone's app store
                </Link>{" "}
                and search for a QR code scanner app. Download and install the app that you prefer. Many free QR code scanner apps are available for iOS and
                Android devices. Position your smartphone's camera so the QR code is within the viewfinder. Make sure the entire QR code is visible within the
                frame. After the app decodes the information, it typically takes you to a webpage or displays the information. Follow the app's instructions to
                access the content or information stored in the QR code.
              </p>
            </div>
          </div>
        </section>

        {/* STATIC AND DYNAMIC */}
        <section className="section-guide-hero-hero paddingLeft wrapperWidth" id="static-and-dynamic">
          <div className="mobile-width-100" style={{ textAlign: "left", margin: "auto" }}>
            <div>
              <h2 className="s3-heading guide-pt-20">
                What is a{" "}
                <span className="gold-color" style={{ fontSize: "inherit" }}>
                  static and dynamic
                </span>{" "}
                QR Code?
              </h2>
              <h4>Static QR Code</h4>
              <p className="s3-text guide-pt-20">
                A static QR code is a type of{" "}
                <Link className="s4-textBlue" to="/qr-code-solution-card">
                  QR code solutions
                </Link>{" "}
                that contains fixed information that cannot be changed. These QR codes are often used for simple applications, such as providing a link to a
                website or displaying contact information. Static QR codes are easy to create and are great for marketing, advertising, and information sharing.
                However, they have some limitations since the information in the code cannot be updated or changed once it has been printed.
              </p>
            </div>

            <div className="mb-5">
              <p className="passupText text-center">Static QR Codes types : </p>
            </div>
            {/* FLEX */}
            <div className="container guide-pt-20">
              <div className="row" style={{ textAlign: "-webkit-center" }}>
                <div class="col-md-3 mt-4  bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #FE8B03 4.81%, #E9B600 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={s1} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">Email QR Code</h5>
                      <p class="card-text">These QR Codes are a convenient way to reach someone without typing their email address.</p>
                    </div>
                  </div>
                </div>
                <div class=" col-md-3 mt-4  bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #0071F5 4.81%, #18B5F9 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={s2} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">WiFi QR Code</h5>
                      <p class="card-text">
                        WiFi QR Code helps is a quick and easy way to join a wireless network without entering the network name and password.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-4  bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #BB0AD8 4.81%, #B6099A 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={s3} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">VCard QR Code</h5>
                      <p class="card-text">
                        It helps easily save the contact information of the designated person or company to your phone without actually entering it.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-4  bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #08B9B8 4.81%, #00A5BA 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={s4} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">SMS QR Code</h5>
                      <p class="card-text">
                        This QR code helps send a text message to the designated phone number and is an easy way to reach someone without manually entering
                        their phone number.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="mobile-width-100"
            style={{
              textAlign: "left",
              margin: "auto",
              marginTop: "40px",
            }}
            bottomMargin
          >
            <div>
              <h4>Dynamic QR Codes</h4>
              <p className="s3-text guide-pt-20">
                Unlike static QR codes, which contain fixed information that cannot be changed, dynamic QR codes can be modified to reflect changes in data,
                such as a new website URL or product price. It allows the information displayed in the QR code to be changed without creating a new code.
                Dynamic QR codes are primarily used in marketing and advertising campaigns, allowing businesses to update their promotions and offers in real
                time.
              </p>
            </div>

            <div className="mb-5">
              <p className="passupText text-center">Dynamic QR Code Types: </p>
            </div>
            {/* FLEX */}
            <div className="container guide-pt-20">
              <div className="row" style={{ textAlign: "-webkit-center" }}>
                <div class="col-md-3 mt-4 bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #FF5F22 4.81%, #FF8496 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={d1} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">Event Registration QR Code</h5>
                      <p class="card-text">
                        It takes the user to a registration page where they can enter their details and sign up for the event and is helpful for conferences,
                        trade shows etc.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-4 bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #C9326F 4.81%, #662F8C 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={d2} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">Product Information QR Code</h5>
                      <p class="card-text">
                        It directs the user to a page with detailed information about the product, including specifications, features, and images.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-4 bottomMargin">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #0BEC8F 4.81%, #006F9B 81.42%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={d3} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">Feedback QR Code</h5>
                      <p class="card-text">
                        It is helpful for businesses looking to improve their customer experience as it takes the user to a feedback form where they can provide
                        their thoughts.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-4">
                  <div
                    class="card profile-card-5"
                    style={{
                      background: "linear-gradient(105.5deg, #C62CC9 37.61%, #FC4DA4 93.05%)",
                      borderRadius: "20px",
                      height: "250px",
                    }}
                  >
                    <div class="card-img-block">
                      <img loading="lazy" class="card-img-top" src={d4} alt="Card  cap" />
                    </div>
                    <div class="card-body pt-0">
                      <h5 class="card-title">Coupon QR Code</h5>
                      <p class="card-text">
                        It directs the user to a page with a coupon or promotional code that they can use to get a discount on a product or service.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className="s3-text guide-pt-20">Help your users seamlessly connect with your services using these simple QR Codes!</p>
            </div>
          </div>
        </section>

        {/* ANATOMY OFA QR CODE */}
        <section className="section-guide-hero anatomy-section paddingLeft">
          <div className="mobile-width-100 wrapperWidth" style={{ textAlign: "left", margin: "auto" }}>
            <div>
              <h2 className="s3-heading guide-pt-20">
                <span className="gold-color" style={{ fontSize: "inherit" }}>
                  Anatomy{" "}
                </span>{" "}
                of QR Code
              </h2>
              <p className="s3-text guide-pt-20">
                The anatomy of a QR code consists of several parts: Finder patterns are large black squares at three QR code corners which help identify the QR
                code's orientation and size. Alignment patterns are smaller black squares located inside the QR code. The alignment patterns help to improve the
                accuracy of the QR code reader when scanning the code. Data region is the area in the center of the QR code that contains the encoded data.
                Quiet zone is the space that surrounds the QR code, it ensures enough contrast between the QR code and its background and no interference from
                other visual elements.
              </p>
            </div>
            <div className="anatomy-wrapper">
              <div className="anatomy-card">
                <div className="row reverseCol">
                  <div className="col-md-4">
                    <img loading="lazy" src={an1} alt="anatomy-img" className="paddingLeft" />
                  </div>
                  <div className="col-md-8">
                    <h2 className="s4-heading">Positioning Detection Markers</h2>
                    <p className="s4-text">
                      QR codes use Positioning Detection Markers to enable scanning devices to detect and orient the code and are located at three corners of
                      the code and consist of a square block and a surrounding area. They have specific sizes and colors to help the scanning device accurately
                      identify the position and orientation of the code.
                    </p>
                  </div>
                </div>
              </div>
              <div className="anatomy-card">
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="s4-heading">Timing Markers</h2>
                    <p className="s4-text">
                      Timing Markers are another essential element of{" "}
                      <Link className="s4-textBlue" to="/help">
                        {" "}
                        QR codes help{" "}
                      </Link>{" "}
                      to scan devices to accurately read the code's information by defining the code's timing and size.
                    </p>
                  </div>
                  <div
                    className="col-md-4 zero-left"
                    style={{
                      position: "relative",
                      left: "100px",
                    }}
                  >
                    <img loading="lazy" src={an2} alt="anatomy-img" width="240px" height={"240px"} className="paddingLeft" />
                  </div>
                </div>
              </div>
              <div className="anatomy-card">
                <div className="row reverseCol">
                  <div className="col-md-4">
                    <img loading="lazy" src={an3} alt="anatomy-img" />
                  </div>
                  <div className="col-md-8">
                    <h2 className="s4-heading">Format Information</h2>
                    <p className="s4-text">
                      QR codes contain Format Information, which defines the code's format and version number. It helps to scan devices to read the code's
                      content accurately.
                    </p>
                  </div>
                </div>
              </div>
              <div className="anatomy-card">
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="s4-heading">Version Information</h2>
                    <p className="s4-text">
                      QR codes have different versions that define their size, capacity, and other features. It helps scanning devices identify the code's
                      version and read it accordingly.
                    </p>
                  </div>
                  <div
                    className="col-md-4 zero-left"
                    style={{
                      position: "relative",
                      left: "100px",
                    }}
                  >
                    <img loading="lazy" src={an4} alt="anatomy-img" className="paddingLeft" />
                  </div>
                </div>
              </div>
              <div className="anatomy-card">
                <div className="row reverseCol">
                  <div className="col-md-4">
                    <img loading="lazy" src={an5} alt="anatomy-img" className="paddingLeft" />
                  </div>
                  <div className="col-md-8">
                    <h2 className="s4-heading">Data and Error Correction Keys</h2>
                    <p className="s4-text">
                      The Data Keys contain the code's data, while the Error Correction Keys add redundancy to the code's data to detect and correct errors that
                      may occur during reading.
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="anatomy-card">
                                  <div className="row">
                                      <div className="col-md-8">
                                          <h2 className="s4-heading">
                                              Version Information
                                          </h2>
                                          <p className="s4-text">
                                              With currently 40 different QR Code
                                              versions, these markers specify the
                                              one that is being used. The most
                                              common ones are versions 1 to 7.
                                          </p>
                                      </div>
                                      <div
                                          className="col-md-4 zero-left"
                                          style={{
                                              position: "relative",
                                              left: "100px",
                                          }}
                                      >
                                          <img  loading="lazy"  
                                              src={an6}
                                              alt="anatomy-img"
                                              className="paddingLeft"
                                          />
                                      </div>
                                  </div>
                              </div>
                              <div className="anatomy-card">
                                  <div className="row reverseCol">
                                      <div className="col-md-4">
                                          <img  loading="lazy"  
                                              src={an7}
                                              alt="anatomy-img"
                                              className="paddingLeft"
                                          />
                                      </div>
                                      <div className="col-md-8">
                                          <h2 className="s4-heading">
                                              Data and error correction keys
                                          </h2>
                                          <p className="s4-text">
                                              The error correction mechanism
                                              inherent in the QR Code structure is
                                              where all your data is contained,
                                              also sharing the space with the
                                              error correction blocks that allow
                                              up to 30% of the Code to be damaged.
                                          </p>
                                      </div>
                                  </div>
                              </div> */}
            </div>
          </div>
        </section>

        <section className="section-guide-hero">
          <div className="mobile-width-90 wrapperWidth" style={{ textAlign: "left", margin: "auto" }}>
            <div className="anatomy-wrapper">
              <div className="marketing-material-card zero-left mobile-text-center" style={{ overflow: "hidden" }}>
                <div className="row scaleDown">
                  <div
                    className="col-md-8 zero-left"
                    style={{
                      paddingLeft: "50px",
                      paddingTop: "50px",
                      paddingBottom: "50px",
                    }}
                  >
                    <h2 className="s4-heading">
                      QR Codes on{" "}
                      <span className="gold-color" style={{ fontSize: "inherit" }}>
                        Marketing Materials{" "}
                      </span>
                    </h2>
                    <p className="s4-text">
                      QR codes have become a popular addition to marketing materials, allowing companies to bridge the gap between offline and online marketing.
                      Incorporating{" "}
                      <Link to="/qr-code-marketing-card" className="s4-textBlue">
                        {" "}
                        QR codes in marketing materials
                      </Link>{" "}
                      is a simple and effective way for businesses to enhance their marketing efforts and connect with a broader audience.
                    </p>
                    <button
                      className="s5-btn"
                      onClick={() => navigateTo("")}
                      style={{
                        backgroundColor: "#58A697",
                        border: "none",
                        color: "#fff",
                      }}
                    >
                      Try Now
                    </button>
                    <button
                      className="s5-btn zero-left-margin"
                      onClick={() => navigateTo("")}
                      style={{
                        backgroundColor: "transparent",
                        border: "2px solid #58A697",
                        color: "#58A697",
                        marginLeft: "30px",
                      }}
                    >
                      Learn More
                    </button>
                  </div>
                  <div
                    className="col-md-2 mobile-width-100"
                    style={{
                      width: "33%",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      loading="lazy"
                      src={marketingImg}
                      style={{
                        borderRadius: "0px 20px 20px 0px",
                      }}
                      alt="marketing"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-guide-hero anatomy-section zero-left" id="uses-of-qr">
          <div className="mobile-width-100 wrapperWidth" style={{ textAlign: "left", margin: "auto" }}>
            <div>
              <h2 className="s3-heading guide-pt-20 text-center">
                <span className="gold-color" style={{ fontSize: "inherit" }}>
                  Common uses{" "}
                </span>{" "}
                of QR Codes
              </h2>
            </div>
            <div className="anatomy-wrapper">
              <div className="common-use-card" style={{ overflow: "hidden" }}>
                <div className="row">
                  <div className="col-md-6">
                    <img loading="lazy" src={cu1} className="mobile-width-100 guide-commonUse-img" height={"100%"} alt="marketing" />
                  </div>
                  <div className="col-md-6 mobile-text-center">
                    <h2 className="s4-heading">Boost app downloads</h2>
                    <p className="s4-text">
                      QR codes can be used to promote and drive downloads of mobile apps. By including a QR code on promotional materials, such as flyers or
                      posters, users can quickly scan the code and be directed to the app store to download the app.
                    </p>
                  </div>
                </div>
              </div>
              <div className="common-use-card" style={{ overflow: "hidden" }}>
                <div className="row reverseCol">
                  <div className="col-md-6 zero-left mobile-text-center" style={{ paddingLeft: "45px" }}>
                    <h2 className="s4-heading">Redeeming coupons gets easier</h2>
                    <p className="s4-text">
                      QR codes can be used on coupons and promotional materials to make it easier for customers to redeem offers. Customers can simply scan the
                      code with their smartphone, and the offer will be applied to their purchase.
                    </p>
                  </div>
                  <div
                    className="col-md-6 zero-left"
                    style={{
                      position: "relative",
                      left: "100px",
                    }}
                  >
                    <img loading="lazy" src={cu2} className="mobile-width-100 guide-commonUse-img" height={"100%"} alt="marketing" />
                  </div>
                </div>
              </div>
              <div className="common-use-card" style={{ overflow: "hidden" }}>
                <div className="row">
                  <div className="col-md-6 zero-left">
                    <img loading="lazy" src={cu3} className="mobile-width-100 guide-commonUse-img" height={"100%"} alt="marketing" />
                  </div>
                  <div className="col-md-6 mobile-text-center">
                    <h2 className="s4-heading">Earn more followers</h2>
                    <p className="s4-text">
                      Social media platforms such as Instagram and Twitter allow users to
                      <Link className="s4-textBlue" to="/">
                        {" "}
                        free qr code generator online
                      </Link>{" "}
                      that others can scan to follow quickly. It is a great way to increase your social media following and engage with your audience.
                    </p>
                  </div>
                </div>
              </div>
              <div className="common-use-card">
                <div className="row reverseCol" style={{ overflow: "hidden" }}>
                  <div className="col-md-6 zero-left mobile-text-center" style={{ paddingLeft: "45px" }}>
                    <h2 className="s4-heading">Give voice to your users</h2>
                    <p className="s4-text">
                      QR codes can be used to collect feedback from customers or users. By including a QR code on a product or service, users can quickly scan
                      the code and provide feedback or suggestions.
                    </p>
                  </div>
                  <div
                    className="col-md-6 zero-left"
                    style={{
                      position: "relative",
                      left: "100px",
                    }}
                  >
                    <img loading="lazy" src={cu4} className="mobile-width-100 guide-commonUse-img" height={"100%"} alt="marketing" />
                  </div>
                </div>
              </div>
              <div className="common-use-card" style={{ overflow: "hidden" }}>
                <div className="row">
                  <div className="col-md-6 zero-left">
                    <img loading="lazy" src={cu3} className="mobile-width-100 guide-commonUse-img" height={"100%"} alt="marketing" />
                  </div>
                  <div className="col-md-6 mobile-text-center">
                    <h2 className="s4-heading">Provide additional information</h2>
                    <p className="s4-text">
                      QR codes can provide additional information about products, services, or events. For example, a
                      <Link className="s4-textBlue" to="/qr-code-marketing-card">
                        {" "}
                        QR code on a product packaging
                      </Link>{" "}
                      can link to a website with product information or instructions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Sixth comp End */}
        <section className="wrapperWidth" id="faq">
          <KnowAbout faq={true} />
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default BeginnersGuide;
